<template>
  <div>
    <div class="rmtj" v-show="$route.name == 'zcfg'">
      <h4>政策法规</h4>
      <el-divider></el-divider>
      <ul>
        <li v-for="item in ggData" :key="item.id" @click="ckxxxx(item.id)">
          {{ item.name
          }}<span style="float: right; margin-right: 5px">{{
            item.putime
          }}</span>
        </li>
      </ul>
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-size="rows"
        layout="total, prev, pager, next"
        :total="datatotal"
        style="text-align: right"
      >
      </el-pagination>
    </div>
    <div class="rmtj1" v-show="$route.name == 'zcfg1'">
      <div class="newLeftFirst" v-for="item in ggData" @click="ckxxxx(item.id)">
        <h2>{{ item.name }}</h2>
        <p>{{ item.journalism }}</p>
        <div class="first">
          <p>{{ item.putime }}</p>
          <!-- <div class="brows">
            <i class="el-icon-view"></i>
            <p>{{ item.countpublic }}</p>
          </div> -->
        </div>
      </div>
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-size="rows"
        layout="total, prev, pager, next"
        :total="datatotal"
        style="text-align: left; margin-top: 20px; margin-bottom: 100px"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { selvypublics } from "../../api/patient";
export default {
  components: {},
  name: "zcfg",
  data() {
    return {
      ggData: [],
      page: 1,
      rows: 6,
      datatotal: 0,
      dentity: "政策法规",
    };
  },
  mounted() {
    this.getSelvypublics();
  },
  methods: {
    handleCurrentChange(val) {
      this.page = val;
      this.getSelvypublics();
    },
    //查看详细信息
    ckxxxx(item) {
      if (this.$route.name == "zcfg") {
        this.$router.push("/newsItem/" + `${item}`);
      } else {
        this.$router.push("/newsItem1/" + `${item}`);
      }
    },
    //获取新闻
    getSelvypublics() {
      let data = new FormData();
      data.append("page", this.page);
      data.append("rows", this.rows);
      data.append("xueyuan", "倒");
      data.append("dentity", this.dentity);
      selvypublics(data).then((res) => {
        this.ggData = res.rows;
        this.datatotal = res.total;
      });
    },
  },
  watch: {},
};
</script>

<style scoped lang="scss">
.rmtj1 {
  // margin-left: 30px;
  width: 100%;
  // display: flex;

  .newLeftFirst {
    width: 800px;
    // height: 163px;
    background: #ffffff;
    border-bottom: 1px solid #dedede;

    h2 {
      height: 19px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
    }

    p {
      height: 17px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      line-height: 25px;
    }

    .first {
      padding-top: 25px;
      display: flex;
      justify-content: space-between;
    }

    .brows {
      display: flex;
      align-items: center;

      p {
        margin-left: 5px;
        display: flex;
        align-items: center;
      }
    }
  }

  .newLeftFirst:hover {
    width: 800px;
    // height: 163px;
    cursor: pointer;
    background: #f6f6f6;
    border-bottom: 1px solid #dedede;

    h2 {
      height: 19px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
    }

    h2:hover {
      height: 19px;
      font-size: 18px;
      cursor: pointer;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #409eff;
    }

    p {
      height: 17px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      line-height: 25px;
    }

    .first {
      padding-top: 25px;
      display: flex;
      justify-content: space-between;
    }

    .brows {
      display: flex;
      align-items: center;

      p {
        margin-left: 5px;
        display: flex;
        align-items: center;
      }
    }
  }
}

.rmtj {
  margin-left: 30px;
  width: 100%;

  h4 {
    width: 72px;
    height: 19px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    line-height: 24px;
  }

  ul {
    display: block;
    list-style-type: disc;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 0px;
    li {
      // height: 17px;
      list-style: disc inside;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      line-height: 70px;
      padding-left: 30px;
      padding-right: 30px;
      border-bottom: 1px solid #eeeeee;
    }

    li:hover {
      // height: 17px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #317df6;
      cursor: pointer;
      line-height: 70px;
      padding-left: 30px;
      padding-right: 30px;
      border-bottom: 1px solid #eeeeee;
      background: #ffffff;
      box-shadow: 0px 2px 4px 0px rgba(155, 155, 155, 0.21);
    }
  }
}
</style>
